import './App.css';
// import Header from './components/Header';
import Navbar from './components/navbar';
import Home from './components/Home'
import LookBook from './components/lookBook';
import CreateAppt from './components/createAppt';
import AboutRaili from './components/aboutRaili'
import {Routes, Route} from 'react-router-dom';
import Footer from './components/Footer'

// import Home from './components/Home'

function App() {
  return (
    <div className="App">
      <Navbar />
      {/* <Home /> */}
          <Routes>
              <Route path='/' element={<Home />}/>
              <Route path='/ourBrides' element={<LookBook />}/>
              <Route path='/schedule' element={<CreateAppt />}/>
              <Route path='/aboutRaili' element={<AboutRaili />}/>
          </Routes>
      <Footer />
    </div>
  );
}

export default App;
